var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no"},[_c('img',{attrs:{"src":require("@/assets/imgs/404.png"),"alt":""}}),_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.$router.push('/home')}}},[_vm._v("返回首页")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }